const main = {
  '--color-primary': '#0C3640',
  '--color-primary-hover': '#1F454E',
  '--color-primary-focus': '#46666D',
  '--color-primary-active': '#287682',
  '--color-primary-disabled': '#A3B3B7',
  '--color-primary-ghost': 'rgba(0, 0, 0, 0.038)',
  '--color-primary-light': '#A3B3B7',
  '--color-primary-dark': '#1F454E',
  '--color-on-primary': '#FFFFFF',
  '--color-text-on-primary': 'rgba(255, 255, 255, 0.87)',
  '--color-secondary': '#9AD9D9',
  '--color-secondary-hover': '#93D0D0',
  '--color-secondary-focus': '#7EB1B1',
  '--color-secondary-active': '#8AC2C2',
  '--color-secondary-disabled': '#A3B3B7',
  '--color-on-secondary': '#0C3640',
  '--color-tertiary': '#287681',
  '--color-error': '#891145',
  '--color-error-background': '#F9CDCE',
  '--color-text-primary': '#000000',
  '--color-text-secondary': '#666666',
  '--color-text-disabled': 'rgba(0, 0, 0, 0.38)',
  '--color-text-on-surface': 'rgba(0, 0, 0, 0.87)',
  '--color-text-on-surface-disabled': 'rgba(0, 0, 0, 0.38)',
  '--color-text-action': '#287681',
  '--color-on-surface': 'rgba(0, 0, 0, 1)',
  '--color-on-surface-hover': 'rgba(0, 0, 0, 0.6)',
  '--color-on-surface-variant': 'rgba(0, 0, 0, 0.6)',
  '--color-surface': '#fff',
  '--color-surface-hover': 'rgba(0, 0, 0, 0.04)',
  '--color-background': '#F2F2F2',
  '--color-border': '#E1E1E1',
  '--color-border-divider': '#F2F2F2',
  '--color-outline': '#C9CACD',
  '--color-grey-100': '#A8A9AE',
  '--color-grey-50': '#BDBEC2',
  '--color-action-check': '#397C0C',
  '--color-action-expanded': '#E7EEEE',
  '--color-action-hover': 'rgba(0, 0, 0, 0.04)',
  '--color-action-selected': 'rgba(0, 0, 0, 0.08)',
  '--color-action-disabled-bg': '#A8A9AE',
  '--color-input-readonly-bg': 'rgba(0, 0, 0, 0.038)',
  '--layout-dialog-max-width': '420px',
  '--font-family': '"Montserrat","Open Sans",-apple-system,BlinkMacSystemFont,"Segoe UI","Roboto","Oxygen","Ubuntu","Cantarell","Fira Sans","Droid Sans","Helvetica Neue",sans-serif',
  '--font-weight-light': 300,
  '--font-weight-regular': 400,
  '--font-weight-medium': 500,
  '--font-weight-bold': 700
};

export default main;
